"use client";
import {
  decryptObject,
  encryptObject,
  generateNonce,
} from "@/helpers/noncehelper";
import axiosInstance from "../config";
const axios: any = axiosInstance();

export const addRecipeList = async (
  path: string,
  token: string,
  encryptedPayload: any
) => {
  try {
    const response = await axios.post(path, encryptedPayload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

// Fetch recipelists
export const getRecipeList = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await axios.get("/recipes/recipesList", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response?.data || [];
  } catch (error) {
    console.error("Error:", error);
  }
};

// Add recipe list
export const addRecipeLists = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await addRecipeList(
      "/recipes/recipesList",
      token,
      encryptedPayload
    );
    return response;
  } catch (err) {
    console.error(err);
  }
};

// Add recipes to list
export const addRecipeToList = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await addRecipeList(
      "/recipes/add-recipes-to-list",
      token,
      encryptedPayload
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Delete Recipe lists
export const deleteRecipeList = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await axios.delete("/recipes/delete-recipes-list", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
      data: encryptedPayload,
    });
    return response?.data;
  } catch (error: any) {
    const err = new Error(
      error?.response?.data?.message ?? "Unknown error"
    ) as Error & {
      code?: any;
    };
    err.code = `${error?.response?.status}` || 500;
    throw err;
  }
};

// Merge recipes lists
export const mergeRecipeList = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await axios.post("/recipes/merge-list", encryptedPayload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error: in api", error);
  }
};
// Delete recipes from list
export const deleteRecipe = async (encryptedPayload: any) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await axios.delete("/recipes/delete-recipe", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
      data: encryptedPayload,
    });
    return response?.data;
  } catch (error: any) {
    const err = new Error(
      error?.response?.data?.message || "Unknown error"
    ) as Error & {
      code?: any;
    };
    err.code = `${error?.response?.status}` || 500;
    throw err;
  }
};

//Recipe Meta Services

export const getRecipePersonalNote = async (encryptedPayload: any) => {
  try {
    const { token, recipe_id } = decryptObject(encryptedPayload) as any;
    const response = await axios.get("/recipes/personal-note", {
      params: {
        recipe_id: recipe_id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response?.data || [];
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const addRecipePersonalNote = async (encryptedPayload: any) => {
  try {
    const { token, note, recipe_id } = decryptObject(encryptedPayload) as any;
    const body = {
      type: "Add",
      personal_note: note,
      recipe_id: recipe_id,
    };

    const response = await axios.post(
      "/recipes/personal-note",
      encryptObject(body),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
          focus: `${token}`,
          "x-nonce-token": generateNonce(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const updateRecipePersonalNote = async (encryptedPayload: any) => {
  try {
    const { token, note, id } = decryptObject(encryptedPayload) as any;
    const body = {
      type: "Edit",
      id: id,
      personal_note: note,
    };
    const response = await axios.post(
      "/recipes/personal-note",
      encryptObject(body),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
          focus: `${token}`,
          "x-nonce-token": generateNonce(),
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const deleteRecipePersonalNote = async (encryptedPayload: any) => {
  const { id, token } = decryptObject(encryptedPayload) as any;
  try {
    const response = await axios.delete("/recipes/personal-note", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
      data: encryptObject({
        id: id,
      }),
    });
    return response?.data;
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};
